import {useRunWorkflow} from '@/biz/workflow.jsx'
import {useMapContext} from '@/components/MindMap/index.mjs'

export default props => {
    const runWorkflow = useRunWorkflow()
    const map = useMapContext()
    const {mapTypeCode} = map.data

    if ('_ISRF_MAP' !== mapTypeCode) {
        return null
    }

    const onClick = () => {
        const {pkid, prjId, sVer} = map.root.data
        const bizMap = {pkid, prjId, sVer}
        runWorkflow({bizMap, scene: 'GENERATE_IMPACT'})
    }

    return {
        label: 'AI变更影响分析',
        onClick,
        ...props
    }
}
